/* eslint-disable eqeqeq */
import { useState } from "react";

import { Button, Card, CardBody, CardText, CardTitle } from "reactstrap";
import getDataFromApi from "../../../../components/getDataFromApi";
import Loader from "../../../../components/Loader";
import Configuration from "../../../../components/modal/NavPanes/Configuration";
import Select from "react-select";
import VersionNav from "./VersionNav";
import useFetch from "../../../../components/useFetch";
import ErrorScreen from "../../../../components/error/ErrorScreen";
import SplitPane, { Pane } from 'split-pane-react';
import 'split-pane-react/esm/themes/default.css'
import { ReactStrapModal } from "../../../../components/reactstrap_modal/ReactStrapModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import DataConfiguration from "../../../../components/modal/NavPanes/DataConfiguration";
export default function VersionDetail({ id, selectdata, preview }) {
  const [formurl, setFormurl] = useState()
  const [fileId, setFileId] = useState();
  const [sizes, setSizes] = useState([100, "10%", "auto"]);
  const url = selectdata ? `datasets/data_hub/${id}/main` : `dataset_versions/${id}/main?page_number=1`;
  const { data, loading, error } = useFetch(url, "get");
  // useEffect(() => {
  //   localStorage.setItem("graphColors", data?.hex_codes);
  // }, [data]);
  //const datasetEntries = Object.entries(selectdata?.metadata.dataset_split);
  if (loading) return <Loader />;
  if (error || data?.info?.dataset_name == undefined) {
    // console.log(error);
    return <ErrorScreen message={"No version Detail Found"} />;
  }
  return (
    <div className="p-2" style={{ width: "100%", height: "100%" }}>
      {data && (

        <SplitPane
          split='vertical'
          sizes={sizes}
          onChange={setSizes}
        >

          <Pane minSize="20%" maxSize='80%' className="col-5" style={{ height: "86vh", overflowY: "auto" }}>

        
            {!preview && <div className="mt-3">
              <DataConfiguration expData={data} />
            </div>}
          </Pane>
          <Pane minSize="20%" maxSize='80%' className="col-7" style={{ height: "87vh" }}>
            <VersionNav data={data} id={id} taskType={data?.task_type} preview={preview} />
            <ReactStrapModal open={formurl?.length > 0} close={() => setFormurl()} path={formurl} />
          </Pane>
        </SplitPane>
      )}
    </div>

  );
}
